import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import {ANIMATION} from "../../../../constants/fields.constants";
import {INPUT_CONTAINER_CLASS, LIST_STATE_VALUE_CLASS} from "../../../../constants/data.constants";
import {DataService} from "../../../../../services/data.service";
import {SearchState} from "../../../../../common/interfaces/data.interfaces";


@Component({
  selector: 'data-states',
  templateUrl: './data-states.component.html',
  styleUrls: ['./data-states.component.scss'],
})
export class DataStatesComponent {
  @Input() animation = ANIMATION;

  @Input() order = 2;
  @Input() showSearchStates = true;
  @Input() states:SearchState[] = [];
  @Output() labelClick = new EventEmitter<any>(true);
  @Output() change = new EventEmitter<any>();

  @Output() clearSearchStates = new EventEmitter<any>(true);

  @Input() showSearchInput = false;
  @Input() searchByMultipleKeys = false;
  @Input() searchKeys = [];
  @Input() searchInputStates:SearchState[] = [];
  @Output() searchInputChange = new EventEmitter<SearchState[]>();

  inputContainerClass = INPUT_CONTAINER_CLASS;
  listStateValueClass = LIST_STATE_VALUE_CLASS;

  constructor(private ds:DataService) {}

  onChange(state:SearchState, value: string){
    if(state.type == 'date') value = this.ds.formatDate(value,state?.format);
    this.change.emit({state, value});
  }

  hasActiveStates(){
    return !!this.states?.find(state => !state.locked && (!!state.value || state.value === false));
  }

}
